import React from 'react';
import './ProjectIntro.css';

const ProjectIntro = () => {
    return (
        <div className="project-intro">

            {/* Section 2: The Council */}
            <section className="intro-section council-section inverted">
                <div className="council-video-container">
                    <video 
                        className="council-background-video" 
                        autoPlay 
                        loop 
                        muted 
                        playsInline
                    >
                        <source src="/img/councilclip.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <div className="council-overlay">
                        <div className="section-container">
                            <h2 className="section-title">The Council</h2>
                            <div className="section-content council-content">
                                <div className="section-text council-text">
                                    <p>
                                        At the core of Immuta's curation system is The Council — 
                                        a governance mechanism powered by Council Tokens. These tokens 
                                        represent both ownership in the curation process and participation 
                                        in the platform's revenue sharing model, ensuring quality while 
                                        providing opportunities for all stakeholders.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Combined Section: Our Vision & Art-First Approach */}
            <section className="intro-section combined-vision-approach-section">
                <div className="section-container">
                    <div className="dual-section-content">
                        <div className="dual-section-item">
                            <h2 className="section-title">Our Vision</h2>
                            <div className="section-content">
                                <div className="section-text">
                                    <p>
                                        Immuta is a revolutionary digital art gallery platform 
                                        that transforms how art is showcased, curated, and 
                                        appreciated in digital spaces. By treating gallery spaces 
                                        themselves as valuable NFTs, we create a unique ecosystem 
                                        where quality art is highlighted in thoughtfully designed 
                                        exhibition environments.
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="dual-section-item">
                            <h2 className="section-title">Art-First Approach</h2>
                            <div className="section-content">
                                <div className="section-text">
                                    <p>
                                        Unlike typical NFT marketplaces that emphasize transactions 
                                        and financial metrics, Immuta takes an art-first approach, 
                                        providing museum-quality presentation with proper context, 
                                        curation, and immersive viewing options. Our focus is on the 
                                        promotion, curation, and appreciation of digital art itself.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 5: Join the Revolution */}
            <section className="intro-section join-section">
                <div className="section-container">
                    <h2 className="section-title">Join the Revolution</h2>
                    <div className="section-content centered">
                        <div className="section-text full-width">
                            <p>
                                Be part of the future of digital art presentation. 
                                Immuta is creating a new ecosystem that benefits artists, 
                                collectors, curators, and space creators alike.
                            </p>
                            <div className="cta-container">
                                <a href="https://immuta.art/whitepaper" className="cta-button">Explore Whitepaper</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProjectIntro;
